$w.onReady(() => {
waitForLoading();
});
export function button6_onClick() {
$w('#').show();
waitForLoading();
}
function waitForLoading() {
var auto_refresh = setInterval(
function()
{
$w('#'). hide('FadeOut').load('#').show('FadeIn');
}, 10000);
}

